/**
 * Jay@airwhizz.com
 * Description :
 *
 * @input :
 * @output :
 *
 *
 */
import React from "react";
import { ataBulkImport } from "../../appRedux/actions/AssetTransferAdvice";
import { connect } from "react-redux";
import { Button, Card, Form, Input, Popover, Spin } from "antd";
import { faviconDynamicFunction } from "../../util/methods";

class ASTImport extends React.Component {
  state = {
    file: {},
  };

  createResource = (values) => {
    // this.props.createResource(values);
  };

  componentDidMount() {
    // this.props.getResourceForImport();
  }

  onFileUpload = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      if (this.state.file) {
        this.props.ataBulkImport({
          file: this.state.file
        });
      }
      this.props.form.resetFields();
    });
  }

  onFileChange = e => {
    this.setState({ file: e.target.files[0] });
  }

  onCheckChange = e => {
    console.log('checked = ', e.target.checked);
    this.setState({ isForRemove: !this.state.isForRemove });
  };

  templateContent = (
    <div>
      <p>CSV file template</p>
      <Button size={'small'} onClick={() => {
        window.open('../csv_template/ATAImportTemplate.csv', '_blank');
      }}>Download</Button>
    </div>
  );

  render() {
    const { match, resource, loading, authUser, resourceName, data, importData } = this.props;
    faviconDynamicFunction(authUser);
    const { getFieldDecorator } = this.props.form;
    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <span><h2>AST Bulk Import</h2><Popover content={this.templateContent} title="" trigger="click">
            <Button type="default" icon="download" size={'small'}>Template</Button>
          </Popover></span>
          <div style={{ marginTop: '30px', marginLeft: '2%', width: '50%' }}>
            <Form onSubmit={this.onFileUpload}>
              <Form.Item label={'File:'}>
                {getFieldDecorator("file", {
                  rules: [{ required: true, message: `File is required!` }],
                })(
                  <Input
                    type="file"
                    accept=".csv"
                    onChange={this.onFileChange}
                  />)}
              </Form.Item>
              <Form.Item>
                <Button
                  type="primary"
                  className="gx-mb-0"
                  htmlType="submit"
                  loading={loading}
                >Upload</Button>
              </Form.Item>
            </Form>
          </div>
        </Card>
        <div>
          {
            // importData && importData.length > 0 ? (<CSVLink data={importData} separator={";"}>Download Log</CSVLink>) : null
          }
        </div>
      </Spin>)
  }
}

const mapStateToProps = ({ commonData, auth, organisation }) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    // modules: commonData.modules,
    // data: organisation.resources,
    // importData: organisation.importData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    // getResource,
    // getResourceForImport,
    ataBulkImport,
  };
}

ASTImport = connect(mapStateToProps, mapDispatchToProps())(ASTImport);
export default Form.create({ name: 'upload' })(ASTImport);
